class SeqRatingTooltip extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.trigger = this.querySelector('button');
    this.content = this.querySelector('[role="tooltip"]');
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (!this.trigger || !this.content) return;

    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.addEventListener('focusin', this.handleFocusIn);
    this.addEventListener('focusout', this.handleFocusOut);
    this.trigger.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('pointerdown', this.handleOutsidePress);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);
    this.trigger?.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('pointerdown', this.handleOutsidePress);
    window.removeEventListener('resize', this.handleResize);
    delete this.dataset.initialized;
  }

  handleMouseEnter = () => {
    if (this.hoverQuery.matches) this.open();
  };

  handleMouseLeave = () => {
    if (this.hoverQuery.matches) this.close();
  };

  handleFocusIn = () => {
    if (this.hoverQuery.matches) this.open();
  };

  handleFocusOut = () => {
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  };

  handleClick = () => {
    if (!this.hoverQuery.matches) this.toggle();
  };

  handleKeydown = (event) => {
    if (event.key !== 'Escape') return;

    this.close();
    this.trigger.focus();
  };

  handleOutsidePress = (event) => {
    if (!this.contains(event.target)) this.close();
  };

  handleResize = () => {
    if (this.hasAttribute('data-open')) this.positionContent();
  };

  positionContent() {
    if (!this.hasAttribute('data-viewport-bound')) return;

    this.content.style.setProperty('--seq-tooltip-shift', '0px');
    const bounds = this.content.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const shift = Math.max(16 - bounds.left, Math.min(0, viewportWidth - 16 - bounds.right));
    this.content.style.setProperty('--seq-tooltip-shift', `${shift}px`);
  }

  toggle() {
    if (this.hasAttribute('data-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.setAttribute('data-open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.content.hidden = false;
    this.positionContent();
  }

  close() {
    this.removeAttribute('data-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.content.hidden = true;
  }
}

if (!customElements.get('seq-rating-tooltip')) {
  customElements.define('seq-rating-tooltip', SeqRatingTooltip);
}
